<template>
<div :class="{ 'body-condensed': !isSidebarShow }" :data-sidebar="isSidebarShow">
	<div class="wrapper">
		<Sidebar :activeSlug="activeSlug" />
		<div class="content-page">
			<div class="content">
				<Header />
				<div class="container-fluid" style="margin-top: 70px;" @click="closeSidebarMobile"> <!-- close sidebar in mobile when click outside sidebar except header component -->
					<div class="row">
						<div class="col-md-12">
							<div class="page page-admin" :class="{ 'layout-full': true }">
								<!-- <AdminHome v-if="activeSlug === 'admin'" /> -->
								<router-view></router-view>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Sidebar from '@/components/inventro/Sidebar.vue';
import Header from '@/components/Header.vue';
// import AdminHome from '@/components/AdminHome.vue';

export default {
	name: 'AdminLayout',
	components: {
		Sidebar,
		Header,
		// AdminHome,
	},
	data() {
		return {
			isRouteChecked: false,
		};
	},
	methods: {
		...mapActions({
			closeSidebarMobile: 'closeSidebarMobile',
		}),
		checkCapabilities() {
			const isCanAccess = this.isAdmin && this.isUserCan(this.pageCapability);
			if (!isCanAccess) {
				if (this.isAdmin && !this.isSupplier && !this.isDropshipper) {
					this.$router.push('/admin');
				} else {
					this.$router.push('/403');
				}

				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Not Authorized',
					text: "You're not authorized to access this page!",
				});
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			isSupport: 'isSupport',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			isMenuActive: 'isMenuActive',
			isFullWidth: 'isFullWidth',
			isHasFeature: 'isHasFeature',
			isSidebarShow: 'isSidebarShow',
			isUserCan: 'isUserCan',
		}),
		activeSlug() {
			return this.$route.meta.slug;
		},
		routerPath() {
			return this.$route.path;
		},
		pageCapability() {
			return this.$route.meta.capabilities ?? '';
		},
	},
	created() {
		if (this.user) {
			this.checkCapabilities();
		}
	},
	watch: {
		routerPath() {
			this.checkCapabilities();
		},
		user() {
			this.checkCapabilities();
		},
	},
};
</script>
